import CostSharing from "./CostSharing";
import { LiaAmbulanceSolid } from "react-icons/lia";
import { GiMedicalDrip } from "react-icons/gi";
import { ImLab } from "react-icons/im";
import { TbEmergencyBed, TbHomeHeart } from "react-icons/tb";
import { IoRadioOutline } from "react-icons/io5";
import { SLOT_NAMES } from "../../../utils/constants";

const step = 14
const StepFourteen = ({ activeStep, control, errors, setValue, getValues }) => {
    if (activeStep !== step) return;

    const template = getValues("template")
    const baseName = 'costShareBenefitDetails.hospitalServices';
    const services = [
        {
            title: 'Inpatient Hospital & Professional Services (including maternity)',
            name: `${baseName}.inpatientHospitalAndServicesIncludingMaternity.type`,
            inNetworkName: `${baseName}.inpatientHospitalAndServicesIncludingMaternity.inNetwork`,
            outOfNetworkName: `${baseName}.inpatientHospitalAndServicesIncludingMaternity.outOfNetwork`,
            category: SLOT_NAMES.INPATIENT
        },
        {
            title: 'Surgery Center & Professional Services',
            name: `${baseName}.outPatientSurgeryCenter.type`,
            inNetworkName: `${baseName}.outPatientSurgeryCenter.inNetwork`,
            outOfNetworkName: `${baseName}.outPatientSurgeryCenter.outOfNetwork`,
            category: SLOT_NAMES.SURGICAL_SERVICES
        },
        {
            title: 'Emergency Room',
            name: `${baseName}.emergencyRoom.type`,
            inNetworkName: `${baseName}.emergencyRoom.inNetwork`,
            outOfNetworkName: `${baseName}.emergencyRoom.outOfNetwork`,
            category: SLOT_NAMES.EMERGENCY_SERVICE,
            //   filterText: 'Penalty', //looing for no emergent
            icon: TbEmergencyBed
        },
        {
            title: 'ER Non Emergent Penalty',
            name: `${baseName}.nonEmergentPenalty.type`,
            inNetworkName: `${baseName}.nonEmergentPenalty.inNetwork`,
            outOfNetworkName: `${baseName}.nonEmergentPenalty.outOfNetwork`,
            category: SLOT_NAMES.ER_NON_EMERGENT_PENALTY
            // searchText: "Penalty",
            // icon: MdOutlineEmergency,
        },
        {
            title: 'Basic Laboratory Services',
            name: `${baseName}.basicLabServices.type`,
            inNetworkName: `${baseName}.basicLabServices.inNetwork`,
            outOfNetworkName: `${baseName}.basicLabServices.outOfNetwork`,
            category: SLOT_NAMES.DIAGNOSTIC_LAB,
            icon: ImLab,
        },
        {
            title: 'Basic Diagnostic/Radiology Services',
            name: `${baseName}.basicDiagnosticRadiologyServices.type`,
            inNetworkName: `${baseName}.basicDiagnosticRadiologyServices.inNetwork`,
            outOfNetworkName: `${baseName}.basicDiagnosticRadiologyServices.outOfNetwork`,
            category: SLOT_NAMES.DIAGNOSTIC_TEST_RADIOLOGY,
            icon: IoRadioOutline,
        },
        {
            title: 'Advanced Diagnostic (MRI/MRA, CT/CTA, PET, Nuclear)',
            name: `${baseName}.advDiagnosticMriMraCtCtaPetNuclear.type`,
            inNetworkName: `${baseName}.advDiagnosticMriMraCtCtaPetNuclear.inNetwork`,
            outOfNetworkName: `${baseName}.advDiagnosticMriMraCtCtaPetNuclear.outOfNetwork`,
            category: SLOT_NAMES.ADVANCED_DIAGNOSTIC,
        },
        {
            title: 'Therapeutic Treatments (Infusion, Dialysis, Chemotherapy, Radiation)',
            name: `${baseName}.outPatientTherapeuticTreatments.type`,
            inNetworkName: `${baseName}.outPatientTherapeuticTreatments.inNetwork`,
            outOfNetworkName: `${baseName}.outPatientTherapeuticTreatments.outOfNetwork`,
            category: SLOT_NAMES.THERAPEUTIC_TREATMENT
        },
        {
            title: 'Colonoscopy',
            name: `${baseName}.colonoscopy.type`,
            inNetworkName: `${baseName}.colonoscopy.inNetwork`,
            outOfNetworkName: `${baseName}.colonoscopy.outOfNetwork`,
            category: SLOT_NAMES.COLONOSCOPY,
        },
        {
            title: 'Home Health Care',
            name: `${baseName}.homeHealthCare.type`,
            inNetworkName: `${baseName}.homeHealthCare.inNetwork`,
            outOfNetworkName: `${baseName}.homeHealthCare.outOfNetwork`,
            category: SLOT_NAMES.HOME_HEALTH,
            icon: TbHomeHeart,
        },
        {
            title: 'Hospice Professional Care',
            name: `${baseName}.hospiceProfCare.type`,
            inNetworkName: `${baseName}.hospiceProfCare.inNetwork`,
            outOfNetworkName: `${baseName}.hospiceProfCare.outOfNetwork`,
            category: SLOT_NAMES.HOSPICE,
        },
        {
            title: 'Durable Medical Equipment',
            name: `${baseName}.durableMedicalEquipment.type`,
            inNetworkName: `${baseName}.durableMedicalEquipment.inNetwork`,
            outOfNetworkName: `${baseName}.durableMedicalEquipment.outOfNetwork`,
            category: SLOT_NAMES.DME,
            icon: GiMedicalDrip,
        },
        {
            title: 'Ambulance',
            name: `${baseName}.ambulance.type`,
            inNetworkName: `${baseName}.ambulance.inNetwork`,
            outOfNetworkName: `${baseName}.ambulance.outOfNetwork`,
            category: SLOT_NAMES.AMBULANCE,
            icon: LiaAmbulanceSolid,
        },
    ].sort((a, b) => a.title?.localeCompare(b.title))

    return (
        <>
            {services?.map(serv => {
                return <div className="cost-sharing-box" key={serv.title}>
                    <CostSharing
                        title={serv.title}
                        name={serv.name}
                        category={serv.category}
                        searchText={serv.searchText}
                        filterText={serv.filterText}
                        template={template}
                        inNetworkName={serv.inNetworkName}
                        outOfNetworkName={serv.outOfNetworkName}
                        control={control}
                        errors={errors}
                        setValue={setValue}
                        icon={serv.icon}
                    />
                </div>
            })}
        </>
    )
}

export default StepFourteen
